<template>
  <div class="flex font-sans tracking-wide relative">

    <!-- Botão de Menu Mobile -->
    <button
      v-if="isMobile"
      @click="expandedMenu(! storeApp.state.menuOpen)"
      class="absolute top-4 left-4 z-50 p-2 rounded-xl focus:outline-none transition-all duration-300 ease-in-out"
      :class="[
        isMobile && storeApp.state.menuOpen ? 'ml-64 set-max-index' : '',
        storeApp.state.menuOpen ? 'text-white' : 'border border-gray-300 text-gray-500 bg-white'
      ]"
    >
      <!-- Ícones do Menu -->
      <MenuIcon v-if="! storeApp.state.menuOpen" class="h-6 w-6" />
      <XMarkIcon v-else class="h-10 w-10" />
    </button>

    <!-- Menu lateral -->
    <div
      :class="[
        'bg-[#fff] h-screen flex flex-col transition-all duration-300 ease-in-out rounded-r-2xl border z-40',
        isMobile && storeApp.state.menuOpen ? 'w-64 absolute set-max-index' : '',
        isMobile && !storeApp.state.menuOpen ? '-ml-24 fixed' : '',
        isDesktop && storeApp.state.menuOpen ? 'w-64' : '',
        isDesktop && !storeApp.state.menuOpen ? 'w-20' : '',
      ]"
      @mouseover="expandedMenu(true)"
      @mouseleave="expandedMenu(false)"
    >
      <!-- Logo e Título -->
      <div
        class="bg-[#f8f8f8] p-5 text-center border-b border-[#e4e4e4] rounded-r-2xl rounded-br-none"
        :class="[
          isMobile && storeApp.state.menuOpen ? 'p-0' : ''
        ]"
      >
        <div
          :class="[
            'justify-end text-left',
            isMobile && storeApp.state.menuOpen ? 'block p-2' : 'flex'
          ]"
        >
          <img
            :key="companyLogo"
            :src="menuLogo"
            alt="BarbApp"
            class="w-10 h-10 mx-auto rounded-full"
            :class="[
              isMobile && storeApp.state.menuOpen ? 'min-w-24 w-24 h-24' : '',
              isDesktop && storeApp.state.menuOpen ? 'min-w-10' : '',
            ]"
          />
          <p
            class="w-full mt-auto mb-auto font-semibold"
            :class="[
              !storeApp.state.menuOpen ? 'hidden' : 'block',
              isMobile && storeApp.state.menuOpen ? 'text-center mt-2' : 'ml-5'
            ]"
          >
            {{ userName }}
          </p>
        </div>
      </div>

      <!-- Opções menu -->
      <section class="flex-1 overflow-y-auto">
        <div class="p-3 pb-2 pl-0 pr-0" :class="[!storeApp.state.menuOpen ? 'text-center' : 'text-left']">
          <p :class="[!storeApp.state.menuOpen ? 'ml-0' : 'ml-5']">
            Menu
          </p>
        </div>
        <nav>
          <ul class="pr-3 pl-3">
            <!-- menus -->
            <div
              v-for="(item, index) in setLinksByPermissions()"
              :key="index"
              class="text-lg"
            >
              <Itens :dataRoute="item" />
            </div>
          </ul>
        </nav>
      </section>

      <!-- Footer menu -->
      <section class="bg-[#f8f8f8] border-t border-[#e4e4e4] rounded-br-2xl rounded-r-none">
        <div class="p-3 pb-2 pl-0 pr-0" :class="[!storeApp.state.menuOpen ? 'text-center' : 'text-left']">
          <p :class="[!storeApp.state.menuOpen ? 'ml-0' : 'ml-5']">
            Outros
          </p>
        </div>
        <nav>
          <ul class="pr-3 pl-3">
            <div
              v-for="(item, index) in exit"
              :key="index"
              class="text-lg"
            >
              <Itens :dataRoute="item" />
            </div>
          </ul>
        </nav>
      </section>
    </div>
    <!-- {{ menuLogo }} -->
    <!-- content -->
    <div
      class="flex-1 max-h-[100vh] p-2 overflow-y-auto overflow-x-auto"
      @click="screenClickMenu()"
    >
      <MenuCoverage
        v-if="isMobile && storeApp.state.menuOpen"
        :key="storeApp.state.setMenuCoverage"
      />
      <slot />
    </div>
  </div>
</template>

<script setup>
import MenuCoverage from './ActivatedMenu.vue'
import Itens from './Itens.vue'
import { ref, computed } from 'vue'
import { storeApp } from '@/store'
import {
  HomeIcon,
  XMarkIcon,
  ChartPieIcon,
  ArrowLeftStartOnRectangleIcon as LogoutIcon,
  Bars3Icon as MenuIcon,
} from '@heroicons/vue/24/outline'
import {
  PhStethoscope,
  PhFolderUser,
  PhAddressBook,
  PhUserPlus
} from '@phosphor-icons/vue'
import SectorForm from '@/modules/extinguisher/layout/SectorForm.vue'
import ConsultasList from '@/modules/extinguisher/layout/pages/ConsultasList.vue'
import MedicosList from '@/modules/extinguisher/layout/pages/MedicosList.vue'
import DoctorForm from '@/modules/extinguisher/layout/DoctorForm.vue'
import { markRaw } from 'vue'

const companyLogo = require('@/assets/logo/icon.png')

const permissions = localStorage.getItem('__permissions')
const userName = localStorage.getItem('__user_name')
const isMobile = computed(() => window.innerWidth < 768)
const isDesktop = computed(() => window.innerWidth >= 768)
const menuLogo = companyLogo

const exit = ref([
  {
    label: 'Sair',
    route: '/logout',
    icon: LogoutIcon
  }
])

const links = ref([
  {
    label: 'Inicio',
    route: '/',
    icon: HomeIcon
  },
  // {
  //   title: 'Gestão',
  //   icon: ChartPieIcon,
  //   subMenu: [
  //     {
  //       label: 'Nova Consulta',
  //       route: '/extinguisher',
  //       icon: PhStethoscope,
  //       component: markRaw(SectorForm)
  //     },
  //     {
  //       label: 'Agenda',
  //       route: '/extinguisher',
  //       icon: PhFolderUser,
  //       component: markRaw(ConsultasList)
  //     },
  //     {
  //       label: 'Médicos',
  //       route: '/extinguisher',
  //       icon: PhAddressBook,
  //       component: markRaw(MedicosList)
  //     },
  //     {
  //       label: 'Novo Médico',
  //       route: '/extinguisher',
  //       icon: PhUserPlus,
  //       component: markRaw(DoctorForm)
  //     },
  //   ]
  // }
])

function screenClickMenu () {
  if (storeApp.state.menuOpen == true && isMobile.value) { storeApp.dispatch('setMenuExpanded', false) }
}

function expandedMenu (value) {
  storeApp.dispatch('setMenuExpanded', value)
}

// define os menus ativos com base nas permissões
function setLinksByPermissions () {
  return links.value
    .map((link) => {
      if (link.subMenu) {
        const filteredSubMenu = link.subMenu.filter((subLink) => {
          if (!subLink.key) return true

          if (Array.isArray(subLink.key)) {
            return subLink.key.some(key => permissions.includes(key))
          } else {
            return permissions.includes(subLink.key)
          }
        })

        if (filteredSubMenu.length > 0) {
          return {
            ...link,
            subMenu: filteredSubMenu
          }
        } else {
          return null
        }
      }

      if (!link.key) return link

      if (Array.isArray(link.key)) {
        if (link.key.some(key => permissions.includes(key))) {
          return link
        }
      } else {
        if (permissions.includes(link.key)) {
          return link
        }
      }

      return null
    })
    .filter((link) => link !== null)
}
</script>

<style scoped>
.set-max-index {
  z-index: 1001 !important;
}
</style>
